import FeatureFlagState from '../../../store-util/FeatureFlagState';
import { FeatureFlags } from '../../../util/flags/types';

export const isEnhancedChartsEnabled = (): boolean => FeatureFlagState.isEnabled(FeatureFlags.use_enhanced_charts);
